import { API } from "../../../utils/api";

export const getStockTagList = async (query) => {
  const res = await API.get(`stock-tags?${query}`);
  return res.data.data;
};

export const createStockTag = async (data) => {
  const { payload } = data;
  const res = await API.post("stock-tags", payload);
  return res.data;
};

export const editStockTag = async (data) => {
  const { id, payload } = data;
  const res = await API.put(`stock-tags/${id}`, payload);
  return res.data;
};

export const removeStockTag = async (id) => {
  const res = await API.delete(`stock-tags/${id}`);
  return res.data;
};

export const removeStockTagItem = async ({ tagId, id }) => {
  const res = await API.delete(`stock-tags/${tagId}/items/${id}`);
  return res.data;
};

export const addItemsToTag = async ({ tagId, payload }) => {
  const res = await API.post(`stock-tags/${tagId}/items`, payload);
  return res.data;
};
